export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./docResource.vue?vue&type=template&id=d5946316&"


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/docResource.vue?vue&type=template&id=d5946316&
// module id = null
// module chunks = 